var TrapFocus = (function () {
    function TrapFocus(container, lastFocusableElement) {
        if (!container)
            return;
        this.container = container;
        this.lastFocusableElement = lastFocusableElement;
        this.init();
    }
    TrapFocus.prototype.init = function () {
        this.keydownFunction = this.handleKeyDown.bind(this);
        document.addEventListener('keydown', this.keydownFunction);
    };
    TrapFocus.prototype.handleKeyDown = function (e) {
        var allFocusableElements = this.container.querySelectorAll('button, a');
        var firstFocusableElement = allFocusableElements[0];
        var lastFocusableElement = this.lastFocusableElement ? this.lastFocusableElement : allFocusableElements[allFocusableElements.length - 1];
        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus();
                e.preventDefault();
            }
        }
        else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                firstFocusableElement.focus();
                e.preventDefault();
            }
        }
    };
    TrapFocus.prototype.removeListener = function () {
        document.removeEventListener('keydown', this.keydownFunction);
    };
    return TrapFocus;
}());
window.TrapFocus = TrapFocus;